const CANCELED_PLAN_WARNING_PERIOD = 15

const FREE_TRIAL_ROUTE_PARAM = 'change'

export { CANCELED_PLAN_WARNING_PERIOD, FREE_TRIAL_ROUTE_PARAM }
